import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialSearchForm } from "./initialState";

import {
  IFlight,
  ISearchForm,
  ISearchPassengers,
} from "./searchForm.interfaces";
import { ICabinType, ITripType } from "@thekilroygroup/shared-ui";

export const searchFormSlice = createSlice({
  name: "search form",
  initialState: initialSearchForm,
  reducers: {
    setTopLevelDomain: (state, action: PayloadAction<ICabinType>) => {
      state.topLevelDomain = action.payload;
    },
    updatePassengers: (state, action: PayloadAction<ISearchPassengers>) => {
      state.passengers = action.payload;
    },
    changeCabinClass: (state, action: PayloadAction<ICabinType>) => {
      state.cabinClass = action.payload;
    },
    changeFlights: (state, action: PayloadAction<IFlight[]>) => {
      state.flights = action.payload;
    },
    changeTripType: (state, action: PayloadAction<ITripType>) => {
      state.tripType = action.payload;
    },
    changeFlexibleSearch: (state, action: PayloadAction<string>) => {
      Number(action.payload) === state.flexibleSearch
        ? (state.flexibleSearch = 0)
        : (state.flexibleSearch = Number(action.payload));
    },
    changeIsValid: (state, action: PayloadAction<boolean>) => {
      state.isValid = action.payload;
    },
    changeSearchRequestId: (state, action: PayloadAction<string>) => {
      state.searchRequestId = action.payload;
    },
    setSearchForm: (state, action: PayloadAction<ISearchForm>) => {
      return action.payload;
    },
    changeSearchFormMetaStorageTimeout: (
      state,
      action: PayloadAction<Date>,
    ) => {
      state.metaStorageTimeout = action.payload;
    },
  },
});

export const {
  setTopLevelDomain,
  updatePassengers,
  changeCabinClass,
  changeFlights,
  changeTripType,
  changeFlexibleSearch,
  changeIsValid,
  changeSearchRequestId,
  changeSearchFormMetaStorageTimeout,
  setSearchForm,
} = searchFormSlice.actions;
